import { combineReducers } from 'redux';

import { commonReducers } from './common';
import { membersReducers } from './members';
import { loaderReducers } from './loader';
import { trainersReducers } from './trainer';
import { batchesReducers } from './batches';
import { membershipPlanReducers } from './membershipPlan';
import { paymentReducers } from './payment';
import { dietPlanReducers } from './dietPlan'

const rootReducer = combineReducers({
  common: commonReducers,
  members: membersReducers,
  loader: loaderReducers,
  trainer: trainersReducers,
  batches: batchesReducers,
  membershipPlan: membershipPlanReducers,
  payment: paymentReducers,
  dietPlan: dietPlanReducers,
});

export default rootReducer;
